<template>
    <div class="main-header">
        <div class="header-update">
            <div class="icon-div">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="380"
                    height="380"
                    viewBox="0 0 480 480"
                    fill="none"
                    class="pattern"
                    opacity="0.4"
                >
                    <defs>
                        <clipPath id="clip-circle">
                            <rect x="190" y="190" width="240" height="240" />
                        </clipPath>
                    </defs>
                    <g clip-path="url(#clip-circle)">
                        <circle cx="240" cy="240" r="47.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="79.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="111.5" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="143.5" stroke="#E4E4E7" />
                    </g>
                </svg>

                <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
                        stroke="#414651"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="title-div">
                <div class="title-wrapper">
                    <span>Update Tags</span>
                    <svg
                        @click="close"
                        class="cursor-pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path
                            d="M18 6L6 18M6 6L18 18"
                            stroke="#A4A7AE"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <p>Update Katherine's Tags</p>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};
</script>
<style lang="scss" scoped>
.main-header {
    @apply flex flex-col items-center pb-5 ;

    .header-update {
        @apply flex items-start gap-4 self-stretch px-6 pt-6;

        .icon-div {
            @apply relative flex flex-col justify-center items-center gap-5 w-12 h-12 p-3 rounded-lg border border-gray-200 bg-white shadow-sm;

            .pattern {
                @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
            }
            .icon {
                @apply absolute w-12 h-12 p-3 rounded-lg border border-gray-200 bg-white shadow-sm;
            }
        }

        .title-div {
             @apply flex flex-col items-start gap-1 flex-1;

            .title-wrapper {
                @apply flex flex-row justify-between self-stretch;

                span {
                    @apply text-gray-900 text-lg font-semibold leading-7;
                }
            }

            p {
                @apply text-gray-600 text-sm font-normal leading-5;
            }
        }
    }
}
</style>
